import { hexToRgb } from '@website/common/utils'
export default {
  DARK: {
    heading: p => p.accentWhite,
    paragraph: p => p.accentWhite,
    background: p => `rgba(${hexToRgb(p.tertiaryDark)}, 1)`,
    ImageStepTitle: p => p.accentWhite,
    ImageStepDescription: p => p.accentWhite,
    counter: p => p.primaryLight
  },
  LIGHT: {
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryNormal,
    background: p => `rgba(${hexToRgb(p.tertiaryLight)}, 1)`,
    ImageStepTitle: p => p.tertiaryDark,
    ImageStepDescription: p => p.tertiaryDark,
    counter: p => p.primaryDark
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryNormal,
    background: p => `rgba(${hexToRgb(p.tertiaryExtraLight)}, 1)`,
    ImageStepTitle: p => p.tertiaryDark,
    ImageStepDescription: p => p.tertiaryDark,
    counter: p => p.primaryDark
  }
}
